/* Intentionally uses ES syntax without lets / consts /arrow functions etc 
as it caters to the lowest common denominator of browser for backwards compatibility when shares fail */
(function (window, document, navigator) {
    'use strict';

    function getShareText(shareData) {
        var parts = [];

        if (shareData.title) {
            parts.push(shareData.title);
        }
        if (shareData.text) {
            parts.push(shareData.text);
        }
        if (shareData.url) {
            parts.push(shareData.url);
        }

        return parts.join('\r\n\r\n');
    }

    function showCopied(button) {
        if (!button) {
            return;
        }

        if (!button.shareOriginalContent) {
            button.shareOriginalContent = button.innerHTML;
        }

        window.clearTimeout(button.shareFeedbackTimeout);
        button.textContent = 'Copied!';
        button.shareFeedbackTimeout = window.setTimeout(function () {
            button.innerHTML = button.shareOriginalContent;
            button.shareOriginalContent = null;
        }, 2000);
    }

    function copyUsingTextArea(text) {
        var textArea = document.createElement('textarea');
        var copied = false;

        textArea.value = text;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();

        try {
            copied = document.execCommand('copy');
        } catch (error) {
            copied = false;
        }

        document.body.removeChild(textArea);
        return copied;
    }

    function copyShareText(shareData, button) {
        var text = getShareText(shareData);

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
                showCopied(button);
            }, function () {
                if (copyUsingTextArea(text)) {
                    showCopied(button);
                } else {
                    window.prompt('Copy this link', shareData.url);
                }
            });
        } else if (copyUsingTextArea(text)) {
            showCopied(button);
        } else {
            window.prompt('Copy this link', shareData.url);
        }
    }

    function share(shareData, button) {
        if (navigator.share) {
            navigator.share(shareData).catch(function (error) {
                if (error.name !== 'AbortError') {
                    copyShareText(shareData, button);
                }
            });
        } else {
            copyShareText(shareData, button);
        }
    }

    function bind(selector, shareData) {
        var buttons = document.querySelectorAll(selector);
        var i;

        for (i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener('click', function () {
                share(shareData, this);
            });
        }
    }

    window.BFSShare = {
        bind: bind
    };
})(window, document, navigator);